import { Heart, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#2C2C2A] text-white/80 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Heart className="w-6 h-6 text-[#C0603A] fill-[#C0603A]" />
              <span className="font-heading text-2xl font-medium text-white">333Oreo</span>
            </div>
            <p className="font-body text-sm text-white/60 leading-relaxed max-w-xs">
              In loving memory of Oreo Henderson. Helping fur parents and their babies,
              one paw at a time.
            </p>
            <p className="font-body text-xs text-white/40 mt-4">
              By LaRonda Shree Enterprises LLC
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-white mb-4">Quick Links</h4>
            <div className="space-y-2">
              {[
                { label: "Pet Pantry", href: "/pet-pantry" },
                { label: "Donate", href: "/donate" },
                { label: "Volunteer", href: "/volunteer" },
              ].map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className="block font-body text-sm text-white/60 hover:text-[#C0603A] transition-colors"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Numbers */}
          <div>
            <h4 className="font-heading text-lg text-white mb-4">Contact Us</h4>
            <div className="space-y-2.5">
              <a href="tel:8885015441" className="flex items-center gap-2 font-body text-sm text-white/60 hover:text-[#C0603A] transition-colors" data-testid="footer-hotline">
                <Phone className="w-3.5 h-3.5 flex-shrink-0" />
                <span>Hotline: (888) 501-5441</span>
              </a>
              <a href="tel:7374159398" className="flex items-center gap-2 font-body text-sm text-white/60 hover:text-[#C0603A] transition-colors" data-testid="footer-corporate">
                <Phone className="w-3.5 h-3.5 flex-shrink-0" />
                <span>Corporate: (737) 415-9398</span>
              </a>
              <a href="tel:6784370829" className="flex items-center gap-2 font-body text-sm text-white/60 hover:text-[#C0603A] transition-colors" data-testid="footer-direct">
                <Phone className="w-3.5 h-3.5 flex-shrink-0" />
                <span>Direct: (678) 437-0829</span>
              </a>
            </div>
          </div>

          {/* Mission */}
          <div>
            <h4 className="font-heading text-lg text-white mb-4">Our Belief</h4>
            <p className="font-body text-sm text-white/60 leading-relaxed italic">
              "Animal Lives Matter Too. As fur parents, our fur babies are our babies
              and are a part of the family."
            </p>
            <p className="font-body text-xs text-white/40 mt-3">
              &mdash; LaRonda Shree Henderson
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-white/40">
            &copy; {new Date().getFullYear()} 333Oreo Foundation. All rights reserved.
          </p>
          <p className="font-body text-xs text-white/40">
            Made with <Heart className="w-3 h-3 inline text-[#C0603A] fill-[#C0603A]" /> for Oreo
          </p>
        </div>
      </div>
    </footer>
  );
}
